import React from "react";
import { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { getFormattedDate, getFormattedTime, getTime } from "../../services/utilities/dateFormatting";
import { convertDateToNumber } from "../../utilities/DateUtils";

interface Props {
    values: any;
}

const CredentialDateInfo: FC<Props> = ({ values }) => {
    const { translate } = useLocale();

    {/*
        Too much lambda just to summaries what is happening here. If both (date and time related i.e startDate and startTime)
        are provided display both else if only date is provided display it else if only time is provided display it else display
        nothing.
    */}
    return <>
        {
            values.startDate && values.startTime ?
                <h4 className="p-1 text-xs text-gray-600">
                    {`${translate.byKey(TranslationKeys.startDate)}:`} <span className="text-sm text-black">{
                        `${getFormattedDate(convertDateToNumber(values.startDate).toString())} ${getFormattedTime(getTime(values.startTime))}`}
                    </span></h4>
                : values.startDate ?
                    <h4 className="p-1 text-xs text-gray-600">
                        {`${translate.byKey(TranslationKeys.startDate)}:`} <span className="text-sm text-black">{
                            `${getFormattedDate(convertDateToNumber(values.startDate).toString())}`}
                        </span></h4>
                    : values.startTime ?
                        <h4 className="p-1 text-xs text-gray-600">
                            {`${translate.byKey(TranslationKeys.startTime)}:`} <span className="text-sm text-black">{
                                `${getFormattedTime(getTime(values.startTime))}`}
                            </span></h4>
                        : null
        }
        {
            values.expiryDate && values.expiryTime ?
                <h4 className="p-1 text-xs text-gray-600">
                    {`${translate.byKey(TranslationKeys.expiryDate)}:`} <span className="text-sm text-black">{
                        `${getFormattedDate(convertDateToNumber(values.expiryDate).toString())} ${getFormattedTime(getTime(values.expiryTime))}`}
                    </span></h4>
                : values.expiryDate ?
                    <h4 className="p-1 text-xs text-gray-600">
                        {`${translate.byKey(TranslationKeys.expiryDate)}:`} <span className="text-sm text-black">{
                            `${getFormattedDate(convertDateToNumber(values.expiryDate).toString())}`}
                        </span></h4>
                    : values.expiryTime ?
                        <h4 className="p-1 text-xs text-gray-600">
                            {`${translate.byKey(TranslationKeys.expiryTime)}:`} <span className="text-sm text-black">{
                                `${getFormattedTime(getTime(values.expiryTime))}`}
                            </span></h4>
                        : null
        }
    </>

} 

export default CredentialDateInfo;